import {gsap} from "gsap";
import {ScrollTrigger} from "gsap/ScrollTrigger";
import {ScrollToPlugin} from "gsap/ScrollToPlugin";

gsap.registerPlugin(ScrollTrigger, ScrollToPlugin);

export default () => {

    const header = document.querySelector<HTMLElement>('#header-outer')
    const adminBar = document.querySelector<HTMLElement>('#wpadminbar')
    const cards = document.querySelector<HTMLElement>('.facetwp-template')
    const filter = document.querySelector<HTMLElement>('.post__filter')

    if (!filter || !header || !cards) {
       return
    }

    document.addEventListener('facetwp-loaded', () => {
        ScrollTrigger.refresh()

        const links = document.querySelectorAll<HTMLElement>('.facetwp-link')

        if (!links) {
            return
        }

        links.forEach(button => {
            button.addEventListener('click', () => {

                const anchor = button.closest<HTMLElement>('.stick')
                const rect =  anchor.getBoundingClientRect()

                gsap.to(window, {
                    duration: 0.5,
                    scrollTo: {
                        y: rect.top + window.scrollY - 300
                    },
                })
            })
        })
     })

    ScrollTrigger.create({
        trigger: filter,
        endTrigger: cards,
        start: () => {
            let totalHeight = header.clientHeight

            if (adminBar) {
                totalHeight = header.clientHeight + adminBar.clientHeight
            }

            return "top " + totalHeight + "px"
        },
        end: () => {
            return "bottom-=12%" + cards + "px"
        },
        pin: true,
        pinSpacing: false,
        toggleClass: 'post__filter--sticky'
    })
}